
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/components/i18n/language-provider';

const WhyChooseKeystle: React.FC = () => {
  const { t } = useLanguage();
  
  const reasons = [
    {
      title: 'Modern Authentication',
      description: 'Complete support for biometric, QR code, and magic link authentication methods.'
    },
    {
      title: 'Built-in Compliance',
      description: 'Ready for audits with integrated consent management and privacy controls.'
    },
    {
      title: 'Advanced Access Control',
      description: 'Sophisticated access management for complex, multi-brand organizations.'
    },
    {
      title: 'Deployment Options',
      description: 'Choose between cloud-based SaaS or dedicated infrastructure deployment.'
    },
    {
      title: 'Predictable Pricing',
      description: 'Transparent cost structure without hidden limitations or forced upgrades.'
    }
  ];

  return (
    <div className="mb-12">
      <h2 className="text-3xl font-bold mb-6 text-center">
        {t('The Keystle Advantage')}
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {reasons.slice(0, 4).map((reason, index) => (
          <Card key={index} className="transition-all duration-300 hover:shadow-md">
            <CardContent className="pt-6">
              <h3 className="font-bold text-xl mb-2">{t(reason.title)}</h3>
              <p>{t(reason.description)}</p>
            </CardContent>
          </Card>
        ))}
        
        <Card className="md:col-span-2 transition-all duration-300 hover:shadow-md">
          <CardContent className="pt-6">
            <h3 className="font-bold text-xl mb-2">{t(reasons[4].title)}</h3>
            <p>{t(reasons[4].description)}</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default WhyChooseKeystle;
